import { getPeriodId } from '../getPeriodId';
import { getServiceId } from '../../../../utils/publishTerms';
import { mapPeriods } from './mapPeriods';
import { IPublishTerm } from '../../../../repositories/billing-tariffs/entities/PublishTerms/PublishTerm';
import { IPeriodsByService } from '../../../../types/reducers/publishTerms';

export function mapPeriodsByService(terms: IPublishTerm[]): IPeriodsByService {
  return terms.reduce((acc, term) => {
    const serviceId = getServiceId(term.services!);
    const rawPeriods = term.periods;

    if (!rawPeriods) {
      acc[serviceId] = { periodIds: [], periods: {} };

      return acc;
    }

    acc[serviceId] = {
      periodIds: rawPeriods.map(getPeriodId),
      periods: mapPeriods(rawPeriods),
    };

    return acc;
  }, {} as IPeriodsByService);
}
